import React, { type ComponentProps, type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { Alert, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuHeaderAlert = (props: Props) => {
  const { children, sizeMatch = DEFAULT_SIZE_MATCH } = props;

  const { match } = useResponsive();

  const containerStyles = match([styles.containerXS, undefined]);

  return (
    <Alert.Container palette="info" style={containerStyles}>
      <Alert.Text sizeMatch={sizeMatch} maxFontSizeMultiplier={1.3}>
        {children}
      </Alert.Text>
    </Alert.Container>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const DEFAULT_SIZE_MATCH: SizeMatch = ['12'];

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    width: '100%',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  sizeMatch?: SizeMatch;
}>;

type SizeMatch = ComponentProps<typeof Alert.Text>['sizeMatch'];
